import React, { useEffect, useState } from 'react';
import mirandaIcon from 'assets/img/miranda-mark.svg';
import { subscribeGlobalLoading } from '../../loading/globalLoading';
import './GlobalLoading.css';

function GlobalLoading() {
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeGlobalLoading(setVisible), []);

  if (!visible) return null;

  return (
    <div className="global-loading" role="status" aria-live="polite" aria-busy="true">
      <div className="global-loading__bubble">
        <span className="global-loading__ring" aria-hidden="true" />
        <span className="global-loading__ring global-loading__ring--delay" aria-hidden="true" />
        <img src={mirandaIcon} alt="" className="global-loading__logo" />
      </div>
      <p className="global-loading__text">Carregando...</p>
    </div>
  );
}

export default GlobalLoading;
